module.exports = __webpack_public_path__ + "img/up_arrow_icon.4fc12c27.svg";